module.exports = __webpack_public_path__ + "media/images/tmp/drama-12497535100a12e452a2757f4e6cd94f.png";